(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const initializeAnnouncementCarousel = (root) => {
    if (root.dataset.initialized === 'true') return;

    const messages = Array.from(root.querySelectorAll('.announcement__message'));
    const control = root.querySelector('[data-announcement-control]');
    const icon = root.querySelector('[data-announcement-icon]');
    const interval = Number(root.dataset.interval) || 5000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let current = 0;
    let timer;
    let manuallyPaused = reducedMotion;

    const stop = () => {
      window.clearInterval(timer);
      timer = undefined;
    };

    const show = (next) => {
      if (next === current) return;
      const outgoing = messages[current];
      const incoming = messages[next];

      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');
      outgoing.setAttribute('aria-hidden', 'true');
      incoming.classList.remove('is-leaving');
      incoming.setAttribute('aria-hidden', 'false');

      window.requestAnimationFrame(() => incoming.classList.add('is-active'));
      window.setTimeout(() => outgoing.classList.remove('is-leaving'), 600);
      current = next;
    };

    const start = () => {
      if (manuallyPaused || messages.length < 2 || document.hidden) return;
      stop();
      timer = window.setInterval(() => show((current + 1) % messages.length), interval);
    };

    const updateControl = () => {
      control.setAttribute('aria-label', manuallyPaused ? root.dataset.playLabel : root.dataset.pauseLabel);
      icon.textContent = manuallyPaused ? '▶' : 'Ⅱ';
    };

    control.addEventListener('click', () => {
      manuallyPaused = !manuallyPaused;
      updateControl();
      if (manuallyPaused) stop();
      else start();
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    root.dataset.initialized = 'true';
    updateControl();
    start();
  };

  document.querySelectorAll('[data-announcement-carousel]').forEach(initializeAnnouncementCarousel);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-announcement-carousel]').forEach(initializeAnnouncementCarousel);
  });


  } catch(e) { console.error(e); }
})();
})();
